import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { WeatherContextComponent } from './weather-context.component';

@NgModule({
  declarations: [WeatherContextComponent],
  imports: [CommonModule, IonicModule],
  exports: [WeatherContextComponent],
})
export class WeatherContextModule {}
